var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"batch-upload-btn"},[_c('a',{on:{"click":_vm.importSelect}},[_vm._v("批量导入被保人")]),_vm._v(" "),_c('input',{staticClass:"faraway import-file",attrs:{"type":"file","accept":".xls,.xlsx"},on:{"change":_vm.importChange}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8778d276","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/insurance/insuranceOrder/insuranceInfo/components/left-insurance-form/components/theInsured-list/components/batch-upload-btn.vue
// module id = null
// module chunks = 